import { DialogActions, MenuItem, Stack, Typography } from '@mui/material';
import {
  CustomButton,
  CustomCheckbox,
  CustomSelect,
  CustomTextField,
  DialogBody,
  DialogContainer,
  DialogTitle,
  HorizontalForm,
} from '../../../../../common/components';

const formatSalePointLabel = (point) => {
  const number = point?.number ? String(point.number) : '';
  const name = point?.name || point?.description || '';
  return name ? `${number} - ${name}` : number || 'Punto de venta';
};

const InvoicePaymentDialog = ({
  open,
  onClose,
  invoiceDate,
  onInvoiceDateChange,
  salePoints,
  salePointsLoading,
  selectedSalePointId,
  onSalePointChange,
  makeElectronicInvoice,
  onMakeElectronicInvoiceChange,
  selectedSalePoint,
  error,
  onSubmit,
  isSubmitting,
}) => {
  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>Facturar pago diferido</DialogTitle>
      <DialogBody>
        <Stack>
          <Typography variant="body2" color="text.secondary">
            Seleccioná los datos para emitir la factura del pago elegido. Solo se pueden facturar
            pagos cobrados.
          </Typography>
          <HorizontalForm withBorder={false} sx={{ mt: 0 }}>
            <CustomTextField
              label="Fecha de factura"
              type="date"
              size="medium"
              value={invoiceDate}
              onChange={(e) => onInvoiceDateChange(e.target.value)}
              sx={{ maxWidth: 250, mr: 1.5 }}
              InputLabelProps={{ shrink: true }}
            />
            <CustomSelect
              label="Punto de venta"
              value={selectedSalePointId || ''}
              onChange={onSalePointChange}
              size="medium"
              disabled={salePointsLoading}
              sx={{ maxWidth: 150 }}
            >
              {salePoints?.map((point) => (
                <MenuItem key={point.uuid} value={point.uuid}>
                  {formatSalePointLabel(point)}
                </MenuItem>
              ))}
            </CustomSelect>
          </HorizontalForm>

          {selectedSalePoint?.invoice ? (
            <CustomCheckbox
              checked={makeElectronicInvoice}
              onChange={(e) => onMakeElectronicInvoiceChange(e.target.checked)}
              label="Generar factura electrónica (CAE)"
            />
          ) : (
            <Typography variant="caption" color="text.secondary">
              Este punto de venta no tiene habilitada la emisión electrónica.
            </Typography>
          )}
          {error && (
            <Typography variant="body2" color="error">
              {error}
            </Typography>
          )}
        </Stack>
      </DialogBody>
      <DialogActions>
        <CustomButton
          variant="base"
          onClick={onSubmit}
          isLoading={isSubmitting}
          disabled={!selectedSalePointId}
        >
          Facturar
        </CustomButton>
        <CustomButton variant="warning" onClick={onClose}>
          Cancelar
        </CustomButton>
      </DialogActions>
    </DialogContainer>
  );
};

export default InvoicePaymentDialog;
